export default __webpack_public_path__ + "static/media/style-artisticTumblelock.6dffd14a.jpg";